import { mixpanel, optimove, ga } from 'js/analytics/adapters'
export const trackLogOut = () => {
  ga.track('Log out')
  mixpanel.track('Log out')
  optimove.track('log_out')
}
